import * as React from 'react';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import { ActivityConfigActions } from './activity-config-actions';
import { IConfigState, IState, IUIState, IUploadState } from '../../../interfaces';

export interface IActivityConfigActionsProps {
  readonly warning: boolean;
}

export interface IActivityConfigActionsStateProps extends IActivityConfigActionsProps {
  readonly ui: IUIState;
  readonly upload: IUploadState;
  readonly config: IConfigState;
}

export type IActivityConfigActionsConnectProps = IActivityConfigActionsStateProps
  & ReactRedux.DispatchProp<Redux.Action>;

export function mapStateToProps(state: IState, props: IActivityConfigActionsProps): IActivityConfigActionsStateProps {
  return {
    ui: state.ui,
    upload: state.upload,
    config: state.config,
    ...props
  };
}

export const ActivityConfigActionsContainer: React.ComponentClass<IActivityConfigActionsProps>
  = ReactRedux.connect(mapStateToProps)(ActivityConfigActions);
